// extracted by mini-css-extract-plugin
module.exports = {"FancyButtons":"style_FancyButtons__3g-xl","cnt":"style_cnt__36Kei"};